/* eslint-disable no-mixed-operators */
import React from "react";
import { connect } from "react-redux";
import { ACCESS_PAGE } from "../Constants/main";
import { loggedUser } from "../Constants/menus";
import { routers } from "../Constants/routers";
import { updateMessages } from "../Redux/Messages/actions";
import { retrieveSettings, updateSettings } from "../Redux/Settings/actions";
import { appendScript, appendStyle, getIcon, saveToStorage } from "./Functions";
import InfoActionPage from "./InfoActionPage";
import LayoutSideMenu from "./LayoutSideMenu";
import LayoutSideMobileMenu from "./LayoutSideMobileMenu";
import CombinedMenus from "./Menus";
import RightPanel from "./Panels/RightPanel";


export const changeAppTheme = () => {
	window.ReactNativeWebView &&
		window.ReactNativeWebView.postMessage(
			JSON.stringify({ message: "themeChange", value: localStorage.theme }),
		);
};

const Layout = (props) => {
	const {
		children,
		sidePanel,
		layout = 1,
		hideCircularMenu,
		title,
		message,
		generals,
		user,
		pageContentClass,
		permissions,
		mustAuth = true
	} = props;

	const openSubMenu = () => {
		let d = document.getElementsByClassName("huro-hamburger nav-trigger");
		if (d && d?.item(0)) d.item(0).click();
	};

    const getSettings = () => {
		props.retrieveSettings();
    }

	
	React.useEffect(() => {
		if(!props?.user?.auth && mustAuth) {
			if (!window.location.pathname.includes(routers.auth.login)) {
				saveToStorage({ name: ACCESS_PAGE, value: window.location.pathname });
			}
			window.location = routers.auth.login;
		}

		appendStyle("assets/css2/app.css");
		appendStyle("assets/css2/main.css");
		getSettings();
		appendScript("assets/js/functions.js")
		appendScript("assets/js/main.js")
		appendScript("assets/js/components.js")
		appendScript("assets/js/popover.js")
		appendScript("assets/js/widgets.js")
		appendScript("assets/js/touch.js")
		appendScript("assets/js/syntax.js")

		if(permissions && !permissions.includes(loggedUser?.role)){
			window.location = routers.dashboard.base;
		}

	}, []);

	if(!user?.auth && mustAuth){
		return (
			<div id="huro-app" className="app-wrapper">
				<div className="app-overlay" />
				<div id={"pageloader"} className={`pageloader is-active`} />
				<div id={"infraloader"} className={`infraloader is-active`} />
			</div>
		)
	}

	return (
		<>
		<div id={"pageloader"} className={`pageloader is-active`} />
		<div id={"infraloader"} className={`infraloader is-active`} />
		<div id="huro-app" className="app-wrapper">
			
			<div className="app-overlay" />
			{/*Pageloader*/}
			{/* Pageloader */}
			<CombinedMenus hideCircularMenu={true} />

			{/*Languages panel*/}
			<RightPanel />

			{/*Activity panel*/}
			<div id="activity-panel" className="right-panel-wrapper is-activity">
				<div className="panel-overlay" />
				<div className="right-panel">
					<div className="right-panel-head">
						<h3>Activity</h3>
						<a className="close-panel">
							<i data-feather="chevron-right" />
						</a>
					</div>
					<div className="tabs-wrapper is-triple-slider is-squared">
						<div className="tabs-inner">
							<div className="tabs">
								<ul>
									<li data-tab="team-side-tab" className="is-active">
										<a>
											<span>Team</span>
										</a>
									</li>
									<li data-tab="projects-side-tab">
										<a>
											<span>Projects</span>
										</a>
									</li>
									<li data-tab="schedule-side-tab">
										<a>
											<span>Schedule</span>
										</a>
									</li>
									<li className="tab-naver" />
								</ul>
							</div>
						</div>
						<div className="right-panel-body">
							<div id="team-side-tab" className="tab-content is-active">
								{/*Team Member*/}
								<div className="team-card">
									<div className="h-avatar">
										<img
											className="avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/avatars/photos/12.jpg"
											alt
										/>
										<img
											className="badge"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/icons/flags/united-states-of-america.svg"
											alt
										/>
									</div>
									<div className="meta">
										<span>Joshua S.</span>
										<span>
											<i data-feather="map-pin" />
											Las Vegas, NV
										</span>
									</div>
									<a className="link">
										<i data-feather="arrow-right" />
									</a>
								</div>
								{/*Team Member*/}
								<div className="team-card">
									<div className="h-avatar">
										<img
											className="avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/avatars/photos/25.jpg"
											alt
										/>
										<img
											className="badge"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/icons/flags/united-states-of-america.svg"
											alt
										/>
									</div>
									<div className="meta">
										<span>Melany W.</span>
										<span>
											<i data-feather="map-pin" />
											San Jose, CA
										</span>
									</div>
									<a className="link">
										<i data-feather="arrow-right" />
									</a>
								</div>
								{/*Team Member*/}
								<div className="team-card">
									<div className="h-avatar">
										<img
											className="avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/avatars/photos/18.jpg"
											alt
										/>
										<img
											className="badge"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/icons/flags/united-states-of-america.svg"
											alt
										/>
									</div>
									<div className="meta">
										<span>Esteban C.</span>
										<span>
											<i data-feather="map-pin" />
											Miami, FL
										</span>
									</div>
									<a className="link">
										<i data-feather="arrow-right" />
									</a>
								</div>
								{/*Team Member*/}
								<div className="team-card">
									<div className="h-avatar">
										<img
											className="avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/avatars/photos/13.jpg"
											alt
										/>
										<img
											className="badge"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/icons/flags/united-states-of-america.svg"
											alt
										/>
									</div>
									<div className="meta">
										<span>Tara S.</span>
										<span>
											<i data-feather="map-pin" />
											New York, NY
										</span>
									</div>
									<a className="link">
										<i data-feather="arrow-right" />
									</a>
								</div>
							</div>
							<div id="projects-side-tab" className="tab-content">
								{/*Project*/}
								<div className="project-card">
									<div className="project-inner">
										<img
											className="project-avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/icons/logos/slicer.svg"
											alt
										/>
										<div className="meta">
											<span>The slicer project</span>
											<span>getslicer.io</span>
										</div>
										<a className="link">
											<i data-feather="arrow-right" />
										</a>
									</div>
									<div className="project-foot">
										<progress
											className="progress is-primary is-tiny"
											value={31}
											max={100}
										>
											31%
										</progress>
										<div className="foot-stats">
											<span>5 / 24</span>
											<div className="avatar-stack">
												<div className="h-avatar is-small">
													<img
														className="avatar"
														src="https://via.placeholder.com/150x150"
														data-demo-src="assets/img/avatars/photos/7.jpg"
														alt
													/>
												</div>
												<div className="h-avatar is-small">
													<img
														className="avatar"
														src="https://via.placeholder.com/150x150"
														data-demo-src="assets/img/avatars/photos/5.jpg"
														alt
													/>
												</div>
												<div className="h-avatar is-small">
													<img
														className="avatar"
														src="https://via.placeholder.com/150x150"
														data-demo-src="assets/img/avatars/photos/8.jpg"
														alt
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								{/*Project*/}
								<div className="project-card">
									<div className="project-inner">
										<img
											className="project-avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/icons/logos/metamovies.svg"
											alt
										/>
										<div className="meta">
											<span>Metamovies reworked</span>
											<span>metamovies.co</span>
										</div>
										<a className="link">
											<i data-feather="arrow-right" />
										</a>
									</div>
									<div className="project-foot">
										<progress
											className="progress is-primary is-tiny"
											value={84}
											max={100}
										>
											84%
										</progress>
										<div className="foot-stats">
											<span>28 / 31</span>
											<div className="avatar-stack">
												<div className="h-avatar is-small">
													<img
														className="avatar"
														src="https://via.placeholder.com/150x150"
														data-demo-src="assets/img/avatars/photos/13.jpg"
														alt
													/>
												</div>
												<div className="h-avatar is-small">
													<img
														className="avatar"
														src="https://via.placeholder.com/150x150"
														data-demo-src="assets/img/avatars/photos/18.jpg"
														alt
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								{/*Project*/}
								<div className="project-card">
									<div className="project-inner">
										<img
											className="project-avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/icons/logos/fastpizza.svg"
											alt
										/>
										<div className="meta">
											<span>Fast Pizza redesign</span>
											<span>fastpizza.com</span>
										</div>
										<a className="link">
											<i data-feather="arrow-right" />
										</a>
									</div>
									<div className="project-foot">
										<progress
											className="progress is-primary is-tiny"
											value={60}
											max={100}
										>
											60%
										</progress>
										<div className="foot-stats">
											<span>25 / 39</span>
											<div className="avatar-stack">
												<div className="h-avatar is-small">
													<img
														className="avatar"
														src="https://via.placeholder.com/150x150"
														data-demo-src="assets/img/avatars/photos/7.jpg"
														alt
													/>
												</div>
												<div className="h-avatar is-small">
													<img
														className="avatar"
														src="https://via.placeholder.com/150x150"
														data-demo-src="assets/img/avatars/photos/25.jpg"
														alt
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div id="schedule-side-tab" className="tab-content">
								{/*Timeline*/}
								<div className="icon-timeline">
									{/*Timeline item*/}
									<div className="timeline-item">
										<div className="timeline-icon">
											<i data-feather="phone-call" />
										</div>
										<div className="timeline-content">
											<p>Call Danny at Colby's</p>
											<span>Today - 11:30am</span>
										</div>
									</div>
									{/*Timeline item*/}
									<div className="timeline-item">
										<div className="timeline-icon">
											<img
												className="avatar"
												src="https://via.placeholder.com/150x150"
												data-demo-src="assets/img/avatars/photos/7.jpg"
												alt
											/>
										</div>
										<div className="timeline-content">
											<p>Meeting with Alice</p>
											<span>Today - 01:00pm</span>
										</div>
									</div>
									{/*Timeline item*/}
									<div className="timeline-item">
										<div className="timeline-icon">
											<i data-feather="message-circle" />
										</div>
										<div className="timeline-content">
											<p>Answer Annie's message</p>
											<span>Today - 01:45pm</span>
										</div>
									</div>
									{/*Timeline item*/}
									<div className="timeline-item">
										<div className="timeline-icon">
											<i data-feather="mail" />
										</div>
										<div className="timeline-content">
											<p>Send new campaign</p>
											<span>Today - 02:30pm</span>
										</div>
									</div>
									{/*Timeline item*/}
									<div className="timeline-item">
										<div className="timeline-icon">
											<i data-feather="smile" />
										</div>
										<div className="timeline-content">
											<p>Project review</p>
											<span>Today - 03:30pm</span>
										</div>
									</div>
									{/*Timeline item*/}
									<div className="timeline-item">
										<div className="timeline-icon">
											<i data-feather="phone-call" />
										</div>
										<div className="timeline-content">
											<p>Call Trisha Jackson</p>
											<span>Today - 05:00pm</span>
										</div>
									</div>
									{/*Timeline item*/}
									<div className="timeline-item">
										<div className="timeline-icon">
											<i data-feather="feather" />
										</div>
										<div className="timeline-content">
											<p>Write proposal for Don</p>
											<span>Today - 06:00pm</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/*Search panel*/}
			<div id="search-panel" className="right-panel-wrapper is-search is-left">
				<div className="panel-overlay" />
				<div className="right-panel">
					<div className="right-panel-head">
						<img
							className="light-image"
							src="assets/img/logos/logo/logo.svg"
							alt
						/>
						<img
							className="dark-image"
							src="assets/img/logos/logo/logo-light.svg"
							alt
						/>
						<a className="close-panel">
							<i data-feather="chevron-left" />
						</a>
					</div>
					<div className="right-panel-body has-slimscroll">
						<div className="field">
							<div className="control has-icon">
								<input
									type="text"
									className="input is-rounded search-input"
									placeholder="Search..."
								/>
								<div className="form-icon">
									<i data-feather="search" />
								</div>
								<div className="search-results has-slimscroll" />
							</div>
						</div>
						<div className="recent">
							<h4>Recently viewed</h4>
							<div className="recent-block">
								<a className="media-flex-center">
									<div className="h-icon is-info is-rounded is-small">
										<i data-feather="chrome" />
									</div>
									<div className="flex-meta">
										<span>Browser Support</span>
										<span>Blog post</span>
									</div>
								</a>
								<a className="media-flex-center">
									<div className="h-icon is-orange is-rounded is-small">
										<i data-feather="tv" />
									</div>
									<div className="flex-meta">
										<span>Twitch API</span>
										<span>Blog post</span>
									</div>
								</a>
								<a className="media-flex-center">
									<div className="h-icon is-green is-rounded is-small">
										<i data-feather="twitter" />
									</div>
									<div className="flex-meta">
										<span>Twitter Auth</span>
										<span>Blog post</span>
									</div>
								</a>
							</div>
						</div>
						<div className="recent">
							<h4>Recent Members</h4>
							<div className="recent-block">
								<a className="media-flex-center">
									<div className="h-avatar is-small">
										<img
											className="avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/avatars/photos/7.jpg"
											alt
											data-user-popover={0}
										/>
									</div>
									<div className="flex-meta">
										<span>Alice C.</span>
										<span>Software Engineer</span>
									</div>
								</a>
								<a className="media-flex-center">
									<div className="h-avatar is-small">
										<img
											className="avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/avatars/photos/13.jpg"
											alt
											data-user-popover={6}
										/>
									</div>
									<div className="flex-meta">
										<span>Tara S.</span>
										<span>UI/UX Designer</span>
									</div>
								</a>
								<a className="media-flex-center">
									<div className="h-avatar is-small">
										<img
											className="avatar"
											src="https://via.placeholder.com/150x150"
											data-demo-src="assets/img/avatars/photos/22.jpg"
											alt
											data-user-popover={5}
										/>
									</div>
									<div className="flex-meta">
										<span>Jimmy H.</span>
										<span>Project Manager</span>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/*Page body*/}

			<LayoutSideMenu />

			<LayoutSideMobileMenu />

			{(layout === 1 && (
				<div
					className="view-wrapper"
					data-naver-offset={214}
					data-menu-item="#layouts-sidebar-menu"
					data-mobile-item="#home-sidebar-menu-mobile"
				>
					<div className="page-content-wrapper">
						<div className={`page-content is-relative ${pageContentClass}`}>
							<div className="page-title has-text-centered">
								{/* Sidebar Trigger */}
								<div
									className="huro-hamburger nav-trigger push-resize"
									data-sidebar="layouts-sidebar"
								>
									<span className="menu-toggle has-chevron">
										<span className="icon-box-toggle">
											<span className="rotate">
												<i className="icon-line-top" />
												<i className="icon-line-center" />
												<i className="icon-line-bottom" />
											</span>
										</span>
									</span>
								</div>
								<div className="title-wrap">
									<h1 className="title is-4">{title}</h1>
								</div>
								<div className="toolbar ml-auto">

									<div className="toolbar-notifications is-hidden-mobile">
										<div className="dropdown is-spaced is-dots is-right dropdown-trigger">
											<div className="is-trigger" aria-haspopup="true" style={{ display: "none" }}>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width={24}
													height={24}
													viewBox="0 0 24 24"
													fill="none"
													stroke="currentColor"
													strokeWidth={2}
													strokeLinecap="round"
													strokeLinejoin="round"
													className="feather feather-bell"
												>
													<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
													<path d="M13.73 21a2 2 0 0 1-3.46 0" />
												</svg>
												<span className="new-indicator pulsate" />
											</div>
										
										</div>
									</div>
								</div>
							</div>
							{message?.alert?.body && (
								<div
									className={`message is-${message?.alert?.type || "primary"}`}
								>
									<div
										class="message-body"
										dangerouslySetInnerHTML={{ __html: `<i style="position: absolute; margin-top: -2px;">${getIcon("bell")}</i><label style="margin-left: 2rem;">${message?.alert?.body}</label>` }}
									/>
								</div>
							)}

							<div className="page-content-inner">
                                {generals?.accountSuspended && <InfoActionPage /> || children}
                            </div>
						</div>
					</div>
				</div>
			)) || <>{generals?.accountSuspended && <InfoActionPage /> || children}</>}
		</div>
		</>
	);
};

const mapStateToProps = ({ messages, generals, settings, user }) => {
	return { message: messages, generals, settings, user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateSettings: (e) => dispatch(updateSettings(e)),
		retrieveSettings: (e) => dispatch(retrieveSettings(e)),
		updateMessages: (e) => dispatch(updateMessages(e)),
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
